import React from 'react'
import { useNavigatorOnline } from '../hooks'

const PlaceHolder = (props) => {
  const { value, transparent, children } = props
  const { isOffline } = useNavigatorOnline()
  if (value !== undefined) {
    if (children) {
      return children
    }
    return value
  }
  let className = ''
  if (!transparent) {
    className += ' background'
  }
  if (isOffline){
    className += ' offline'
  }
  return (
    <div className={`pwa__placeholder ${className}`}>
      <div className="bar"></div>
    </div>
  )
}

export default PlaceHolder
